import { render, staticRenderFns } from "./SingleNotification.vue?vue&type=template&id=af649ef6&scoped=true&"
import script from "./SingleNotification.vue?vue&type=script&lang=js&"
export * from "./SingleNotification.vue?vue&type=script&lang=js&"
import style0 from "./SingleNotification.vue?vue&type=style&index=0&id=af649ef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af649ef6",
  null
  
)

export default component.exports